import { defineInlineAdSlotSchema } from "~/components/content/content-schema-render/inline-ad-slot/schemas";
import { defineTrackViewedPercentageSchema } from "~/components/content/content-schema-render/track-viewed-percentage/schemas";

export const StyleCustomContents = [
  defineInlineAdSlotSchema({ row: 4, tag: "0" }),
  defineInlineAdSlotSchema({ row: 8, tag: "1" }),
  defineInlineAdSlotSchema({ row: 12, tag: "2" }),
  defineTrackViewedPercentageSchema({
    percentage: "50",
    row: 13,
  }),
  defineInlineAdSlotSchema({ row: 16, tag: "3" }),
  defineInlineAdSlotSchema({ row: 20, tag: "4" }),
  defineInlineAdSlotSchema({ row: 24, tag: "5" }),
  defineInlineAdSlotSchema({ row: 28, tag: "6" }),
  defineTrackViewedPercentageSchema({
    percentage: "100",
    row: -1,
  }),
  defineInlineAdSlotSchema({ row: -1, tag: "7" }),
];
